import orderBy from 'lodash/orderBy';
import { useQuery } from 'react-query';

import notificationsService from '../core/services/notifications.service';
import { useIsAnonymous, useMe } from '../profile/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useNotifications = (): any => {
  const user = useMe();
  const isAnonymous = useIsAnonymous();
  const enabled = !(!user || isAnonymous);
  const res = useQuery(
    ['notifications', user._id],
    async () => {
      const notifications = await notificationsService.getNotifications();
      return orderBy(notifications, 'createdAt', 'desc') || [];
    },
    {
      enabled,
    },
  );
  // @Patrick - Utilisation de websockets pour gérer le polling ?

  return {
    notifications: res.data,
    loading: res.status === 'loading',
    enabled,
  };
};

export { useNotifications };
